import type { FacetsWithValues } from "@/modules/jobAds/client/utils/getAlgoliaFacetFiltersFromParams"

import _cloneDeep from "lodash/cloneDeep"

import { AND_OPERATOR, NOT_OPERATOR, NOT_OPERATOR_SUBSTITUTE, OR_OPERATOR } from "@/modules/jobAds/client/constants"
import { logger } from "@/modules/monitoring/logger"

const formatAlgoliaFiltersValues = (facet: string[]): string => {
  if (facet.length > 1) {
    return `( ${facet.join(` ${OR_OPERATOR} `)} )`
  }
  const singleFacet = facet[0]
  if (singleFacet.charAt(0) === NOT_OPERATOR_SUBSTITUTE) {
    return singleFacet.replace(NOT_OPERATOR_SUBSTITUTE, `${NOT_OPERATOR} `)
  }
  return singleFacet
}

export const formatFiltersForAlgolia = (filters: FacetsWithValues, excludedFacet?: keyof FacetsWithValues): string => {
  let filtersToFormat: Partial<FacetsWithValues> = _cloneDeep(filters)
  if (excludedFacet !== undefined) {
    const { [excludedFacet]: _, ...restFilters } = filters
    filtersToFormat = restFilters
  }

  const filtersValues: string[][] = []
  const is2DArray = (facet: string[] | string[][]): facet is string[][] => facet.every(item => Array.isArray(item))

  Object.values(filtersToFormat)
    .filter(facet => facet.length > 0)
    .forEach(facet => {
      if (is2DArray(facet)) {
        facet.forEach(item => filtersValues.push(item))
      } else {
        filtersValues.push(facet)
      }
    })

  const mappedFiltersValues = filtersValues.map(facet => [...new Set(facet)]).map(formatAlgoliaFiltersValues)
  const effectiveFiltersValues = mappedFiltersValues.filter(Boolean)

  if (mappedFiltersValues.length !== effectiveFiltersValues.length) {
    logger.info(`Some filters were removed because they were empty or invalid: ${JSON.stringify(filtersValues)}`)
  }

  return effectiveFiltersValues.join(` ${AND_OPERATOR} `)
}
